/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Forgot_PasswordInputs */



/**
* | output |
* | --- |
* | "Forgot password?" |
*
* @param {Login_Forgot_PasswordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_forgot_password = /** @type {((inputs?: Login_Forgot_PasswordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Forgot_PasswordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mot de passe oublié ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Olvidó su contraseña?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Esqueceu a senha?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Password dimenticata?")
	return /** @type {LocalizedString} */ ("Forgot password?")
});